import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center">
        <div className="w-full mb-10 md:mb-14 overflow-hidden rounded-2xl md:rounded-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=Breaking%20news%20studio%20with%20dramatic%20red%20lighting%20and%20multiple%20screens%20displaying%20headlines%2C%20newsroom%20atmosphere%2C%20cinematic%20broadcast%20setting%2C%20professional%20studio%20equipment%2C%20dark%20and%20intense%20mood%2C%20film%20grain%20texture%2C%20dramatic%20contrast%20lighting&width=1200&height=500&seq=cta-breaking-news&orientation=landscape"
            alt="爆料入口"
            title="51吃瓜爆料入口 - 最新吃瓜网址已同步"
            className="w-full h-56 md:h-72 object-cover object-top"
          />
        </div>

        <div className="mb-8 md:mb-10">
          <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-black text-foreground-900 leading-snug">
            吃瓜无罪
          </p>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading italic text-foreground-500 font-normal leading-snug my-1 md:my-2">
            八卦有理
          </p>
          <p className="text-xl md:text-2xl font-heading font-semibold text-foreground-700 leading-snug">
            高清资源在线看不停
          </p>
        </div>

        <Link
          to="/category/latest"
          className="inline-flex items-center gap-2 px-10 py-3.5 md:px-12 md:py-4 bg-foreground-900 hover:bg-foreground-800 text-background-50 text-sm md:text-base font-label font-semibold rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
        >
          获取最新入口
          <i className="ri-arrow-right-line text-lg"></i>
        </Link>
      </div>
    </section>
  );
}